import React from 'react';
import { Bell } from 'lucide-react';
import { Tooltip } from '../ui/Tooltip';

interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'info' | 'warning' | 'success' | 'error';
  timestamp: string;
  read: boolean;
}

interface NotificationBadgeProps {
  notifications: Notification[];
  onOpen: () => void;
}

export function NotificationBadge({ notifications, onOpen }: NotificationBadgeProps) {
  const unreadCount = notifications.filter((n) => !n.read).length;

  return (
    <Tooltip content="View notifications">
      <button
        type="button"
        onClick={onOpen}
        className="relative rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        <Bell className="h-6 w-6" />
        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-medium text-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
    </Tooltip>
  );
}